// export const EMAIL_PATTERN = `^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$`;
export const EMAIL_PATTERN = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$";
export const EMAIL_TITLE = 'Please enter a valid email address.';
export const EMAIL_MAX_Length = 254;
export const PASSWORD_MIN_Length = 8;
export const PASSWORD_MAX_Length = 125;
export const PASSWORD_PATTERN = `(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&]).{${PASSWORD_MIN_Length},}`;
export const PASSWORD_TITLE = "Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.";

export const RESET_OTP_MAX_Length = 6;
export const RESET_OTP_PATTERN = "[0-9]*";
export const RESET_OTP_TITLE = "Only numbers are allowed";

export const MOBILE_NUMBER_MIN_LENGTH = 10;
export const MOBILE_NUMBER_MAX_LENGTH = 10;
export const MOBILE_NUMBER_PATTERN = "\\d{10}";
export const MOBILE_NUMBER_TITLE = "Please enter a valid 10-digit mobile number";

export const PINCODE_MINIMUM_LENGTH = 5;
export const PINCODE_MAXIMUM_LENGTH = 10;
export const PINCODE_PATTERN = `\\d{4,10}`;
export const PINCODE_TITLE = "Please enter a valid pincode";

export const NAME_TEXT_PATTERN = "^[A-Za-z\\s]*$";
export const NAME_TEXT_MIN_LENGTH = 3;
export const NAME_TEXT_MAX_LENGTH = 75;
export const NAME_TEXT_TITLE = "Name must contain only letters and spaces and at least 3 and between 75 characters long";
export const HOSPITAL_NAME_PATTERN ="/^[a-zA-Z0-9\s&' -]+$/";
export const HOSPITAL_NAME_TEXT_TITLE = "Name must be at least 3 characters long";

export const DEVICE_NUMBER_MIN_LENGTH =16;
export const DEVICE_NUMBER_MAX_LENGTH =16;
export const DEVICE_NUMBER_PATTERN =".{16,}";
export const DEVICE_NUMBER_TITLE = "Device Unique ID must be exactly 16 digits number.";

export const TELEPHONE_NUMBER_PATTERN = "^[0-9]*$";
export const TELEPHONE_NUMBER_MIN_LENGTH = 10;
export const TELEPHONE_NUMBER_MAX_LENGTH = 15;
export const TELEPHONE_NUMBER_TITLE ="Phone number should be between 10 to 15 digit numbers";

export const GST_NUMBER_PATTERN = "/^[0-9A-Z]{15}$/";
export const GST_NUMBER_MAX_LENGTH = 15;
export const GST_NUMBER_MIN_LENGTH = 15;
export const GST_NUMBER_TITLE = "Please enter a valid 15-digit GST number.";

export const ADDRESS_MAX_LENGTH = 100;
export const DEVICE_NAME_TITLE = 'Device name must be at least 3 characters long';
export const DEVICE_NAME_MIN_LENGTH = 3;
export const DEVICE_NAME_MAX_LENGTH = 50;

export const WEBSITE_PATTERN = "^(https?:\\/\\/|www\\.)[\\w-]+(\\.[\\w-]+)+(\\/\\S*)?$";
export const WEBSITE_TITLE = "Please enter a valid URL starting with http:// or https://"

export const DATA_TEXT_MIN_LENGTH = 3;
export const DATA_TEXT_MAX_LENGTH = 50;
